const PaymentType = {
  card: '0',
  bank: '1'
};

export default PaymentType;



// WEBPACK FOOTER //
// ./src/constants/payment-type.js